import { Box, CircularProgress } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { remixerApi } from 'services/api/remixer';
import EmptyState from '../EmptyState';
import StudioProjectItem from '../StudioProjectItem';
import {
  ButtonContainer,
  CustomLoadingButton,
  LoaderContainer,
  ProjectsListWrapper,
} from './styled';

const StudioProjectList = () => {
  const { t } = useTranslation();
  const [page, setPage] = useState(1);

  const { data, isLoading, isFetching, isError } =
    remixerApi.useGetProjectsQuery(page);

  if (isLoading) {
    return (
      <LoaderContainer>
        <CircularProgress />
      </LoaderContainer>
    );
  }

  if (isError) {
    return <Box>{t('library:projects:getProjectsErrorMessage')}</Box>;
  }

  if (!data?.studioProjects.length) {
    return <EmptyState />;
  }

  return (
    <ProjectsListWrapper>
      {data.studioProjects.map((project) => (
        <StudioProjectItem key={project.id} project={project} />
      ))}

      {!data.isLastPage && (
        <ButtonContainer>
          <CustomLoadingButton
            variant="outlined"
            loading={isFetching}
            onClick={() => setPage(page + 1)}
          >
            {t('general:action:loadMore')}
          </CustomLoadingButton>
        </ButtonContainer>
      )}
    </ProjectsListWrapper>
  );
};

export default StudioProjectList;
